import { Component, OnInit } from '@angular/core';
import Action from 'src/app/models/action';
import { ModalController, NavController, AlertController } from '@ionic/angular';
import { ActionService } from 'src/app/services/action.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from 'src/app/services/global.service'
import Contact from 'src/app/models/contact';
import { SelectContactsPage } from '../select-contacts/select-contacts.page';

@Component({
  selector: 'app-select-touchpoints',
  templateUrl: './select-touchpoints.page.html',
  styleUrls: ['./select-touchpoints.page.scss'],
})
export class SelectTouchpointsPage implements OnInit  {
  public actions: Action[] = [];
  public selectedContacts: Contact[];
  public selectedActions: Action[];
  public isLoadingActions: Boolean;
  public fetchNewActions: boolean = true;
  public visibleActions;
  public visibleTouchpoints: Action[] = [];
  public hasMoreActions: boolean = false;
  public isIosDevice: boolean = false;
  public skeletonRows: number[] = [1,2,3,4,5];
  private allTouchpoints: Action[] = [];
  private selectedActionIds: Set<number> = new Set();
  private actionRenderLimit: number = 60;
  private actionRenderStep: number = 60;

  constructor(
    private modalController: ModalController,
    private navController: NavController,
    private actionService: ActionService,
    private alertController: AlertController,
    private translateService: TranslateService,
    private globalService: GlobalService
  ) {}

  public async ngOnInit () {
    GlobalService.log("Selected Actions:");
    GlobalService.log(this.selectedActions);
    if(this.selectedActions == undefined){
      this.selectedActions = [];
    }
    this.isIosDevice = this.globalService.isIos();
    this.updateSelectedActionIds();
    await this.ionViewDidEnterManual();
  }

  public ionViewDidEnterManual () {
    if (this.fetchNewActions) {
      this.getActions();
    } else { 
      this.fetchNewActions = true; // Ensure fetchNewContacts is on for future contact selects
    }
  }

  public searchActions(eventData){
    const sourceActions = ActionService.SearchedActions || this.allTouchpoints;
    if(eventData.detail.value){
      let searchValue = eventData.detail.value.toLowerCase();
      GlobalService.log(searchValue);
      GlobalService.log(ActionService.SearchedActions);

      this.actions = sourceActions.filter(action => action.title && action.title.toLowerCase().includes(searchValue));
      this.resetActionRenderLimit();
      this.updateVisibleTouchpoints();
      GlobalService.log(this.actions);
    } else {
      this.actions = [...sourceActions];
      this.resetActionRenderLimit();
      this.updateVisibleTouchpoints();
    }
  }

  public searchedActions(){
    return ActionService.SearchedActions;
  }

  public getActions () {
    this.isLoadingActions = true;

    this.actionService.getActionsByStatus(2).then(actions => {
      this.actions = [];
      actions.forEach(action => {
        if(action.status && action.status > 1){
          this.actions.push(action);
        }
      });

      this.allTouchpoints = [...this.actions];
      ActionService.SetSearchedActions(this.allTouchpoints);
      this.updateVisibleTouchpoints();
      this.isLoadingActions = false;
    }).catch(async err => {
      this.isLoadingActions = false;      
      let buttons = [];
      buttons.push({
        cssClass: "cancelButton",
        text: 'OK',
        handler: () => {
          this.dismiss(false);
        }
      });

      this.globalService.ionicAlert(
        buttons,
        "ERROR",
        "LOADINGACTIONSFAILED",
        "custom-alert",
        true,
        true
      );
    });
  }

  public dismiss(dismissed) {
    GlobalService.log(this.selectedActions);
    GlobalService.log(dismissed);
    
    this.modalController.dismiss({
      dismissed: dismissed,
      touchpoints: this.selectedActions
    });
  }

  public goBack() {
    this.dismiss(false);
  }

  public submit() {
    this.dismiss(true);
  }

  private compareActions (action: Action) {
    return x => (action.id_action != undefined && x.id_action == action.id_action);
  }

  public actionIsSelected (action: Action): boolean {
    if(action.id_action == undefined) return this.selectedActions.find(this.compareActions(action)) != undefined;
    return this.selectedActionIds.has(action.id_action);
  }

  public selectAction (action: Action) {
    if (this.actionIsSelected(action)) {
      this.selectedActions.splice(this.selectedActions.findIndex(this.compareActions(action)),1);
    } else {
      this.selectedActions.push(action);
    }
    this.updateSelectedActionIds();
  }

  public loadMoreActions($event = undefined) {
    this.actionRenderLimit += this.actionRenderStep;
    this.updateVisibleTouchpoints();
    if($event) $event.target.complete();
  }

  public async selectActions() {
    const modal = await this.modalController.create({
      component: SelectContactsPage,
      cssClass: "fullscreen-modal",
      componentProps: {
        selectedContacts: this.selectedContacts,
      },
    });

    modal.onDidDismiss().then((data) => {
      this.selectedContacts = data.data.actions;
    });

    return await modal.present();
  }
  
  public async selectTouchpoints() {
    const modal = await this.modalController.create({
      component: SelectContactsPage,
      cssClass: "fullscreen-modal",
      componentProps: {
        selectedContacts: this.selectedContacts,
      },
    });

    modal.onDidDismiss().then((data) => {
      this.selectedContacts = data.data.touchpoints;
    });

    return await modal.present();
  }

  public selectAll () {
    if (this.selectedActions.length == this.actions.length) {
      this.selectedActions = [];
    } else {
      this.selectedActions = [...this.actions]
    }
    this.updateSelectedActionIds();
  }
  
  isIos(){
    return this.globalService.isIos();
  }

  public trackByAction(index: number, action: Action) {
    return action?.id_action || index;
  }

  public trackByIndex(index: number) {
    return index;
  }

  private updateSelectedActionIds() {
    this.selectedActionIds = new Set((this.selectedActions || []).filter(action => action.id_action != undefined).map(action => action.id_action));
  }

  private updateVisibleTouchpoints() {
    this.visibleTouchpoints = this.actions.slice(0, this.actionRenderLimit);
    this.hasMoreActions = this.visibleTouchpoints.length < this.actions.length;
  }

  private resetActionRenderLimit() {
    this.actionRenderLimit = this.actionRenderStep;
  }
}
